import React, { memo } from 'react';
import { ActionButton } from '@adobe/react-spectrum';
import { CommonTooltip } from './CommonTooltip';
import styles from './TooltipCell.module.scss';

interface TooltipCellProps {
  value: string | React.ReactNode;
  /** When set, used for the hover tooltip instead of `value`. */
  tooltipContent?: string | React.ReactNode;
  className?: string;
  onClick?: () => void;
  style?: React.CSSProperties;
  testId?: string;
}

export const TooltipCell: React.FC<TooltipCellProps> = memo(
  ({ value, tooltipContent, className, onClick, style, testId }) => {
    const combinedClassName = `${styles.tooltipCell} ${className || ''}`;

    return (
      <CommonTooltip tooltipContent={tooltipContent ?? value}>
        <ActionButton
          UNSAFE_className={combinedClassName}
          UNSAFE_style={style}
          isQuiet
          onPress={onClick}
          data-testid={testId}
        >
          {value}
        </ActionButton>
      </CommonTooltip>
    );
  }
);

TooltipCell.displayName = 'TooltipCell';
